import { slotBarSymbolNames, slotSpineKey } from '../constants/symbolsNames';
import { isMobile } from '../helpers/isMobile';

const fonts = {
  font: { name: 'HEYCAZpersonal', path: 'atlases/fonts/HEYCAZpersonal.otf' },
  font1: { name: 'poppinsMedium', path: 'atlases/fonts/poppinsMedium.ttf' },
};

const bitmapFonts = {
  numbersJackpot: { name: 'numbersJackpot', path: 'atlases/bitmapFonts/numbersJackpot.xml' },
  totlWinNumbers: { name: 'totlWinNumbers', path: 'atlases/bitmapFonts/totlWinNumbers.xml' },
  winPopupNumbers: { name: 'winPopupNumbers', path: 'atlases/bitmapFonts/winPopupNumbers.xml' },
};

const webSceneSpineResources = {
  1: {
    name: slotBarSymbolNames.icon1,
    path: 'atlases/slotCharacters/web/symbol1/symbol1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol1/symbol1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  2: {
    name: slotBarSymbolNames.icon2,
    path: 'atlases/slotCharacters/web/symbol2/symbol2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol2/symbol2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  3: {
    name: slotBarSymbolNames.icon3,
    path: 'atlases/slotCharacters/web/symbol3/symbol3.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol3/symbol3.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  4: {
    name: slotBarSymbolNames.icon4,
    path: 'atlases/slotCharacters/web/symbol4/symbol4.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol4/symbol4.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  5: {
    name: slotBarSymbolNames.icon5,
    path: 'atlases/slotCharacters/web/symbol6/symbol6.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol6/symbol6.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  6: {
    name: slotBarSymbolNames.icon6,
    path: 'atlases/slotCharacters/web/symbol7/symbol7.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol7/symbol7.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  7: {
    name: slotBarSymbolNames.icon7,
    path: 'atlases/slotCharacters/web/symbol5/symbol5.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol5/symbol5.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  8: {
    name: slotBarSymbolNames.icon8,
    path: 'atlases/slotCharacters/web/symbol8/symbol8.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol8/symbol8.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  9: {
    name: slotBarSymbolNames.icon9,
    path: 'atlases/slotCharacters/web/wild/wild.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/wild/wild.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  10: {
    name: slotBarSymbolNames.icon11,
    path: 'atlases/slotCharacters/web/scatter2/scatter2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/scatter2/scatter2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  11: {
    name: slotBarSymbolNames.icon10,
    path: 'atlases/slotCharacters/web/scatter1/scatter1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/scatter1/scatter1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  400: {
    name: slotBarSymbolNames.icon12,
    path: 'atlases/slotCharacters/web/jackpotSymbol/jackpotSymbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/jackpotSymbol/jackpotSymbol.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  jackpotCongratsPopup: {
    name: slotSpineKey.jackpotCongratsPopup,
    path: 'atlases/jackpotAssets/web/jackpotCongratsPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotCongratsPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    name: slotSpineKey.jackpotGameSceneBoard,
    path: 'atlases/jackpotAssets/web/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackPotItem: {
    name: slotSpineKey.jackPotItem,
    path: 'atlases/jackpotAssets/web/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    name: slotSpineKey.jackpotAmountBoard,
    path: 'atlases/jackpotAssets/web/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackPotSymbol: {
    name: slotSpineKey.jackPotSymbol,
    path: 'atlases/jackpotAssets/web/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopup: {
    name: slotSpineKey.jackpotWinPopup,
    path: 'atlases/jackpotAssets/web/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  mainBg: {
    name: slotSpineKey.mainBg,
    path: 'atlases/mainBg/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/mainBg/web/background.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  board: {
    name: slotSpineKey.board,
    path: 'atlases/board/web/Board.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/board/web/Board.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winPopup: {
    name: slotSpineKey.winPopup,
    path: 'atlases/winPopup/web/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winPopup/web/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winLine: {
    name: slotSpineKey.winLine,
    path: 'atlases/line/web/line.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/line/web/line.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gameLogo: {
    name: slotSpineKey.gameLogo,
    path: 'atlases/logo/web/Logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/logo/web/Logo.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gambleAmountFrame: {
    name: slotSpineKey.gambleAmountFrame,
    path: 'atlases/gambleFuture/web/amountFrame/amount.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/web/amountFrame/amount.atlas',
      },
    },
  },
  gambleCard: {
    name: slotSpineKey.gambleCard,
    path: 'atlases/gambleFuture/web/card/card.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/web/card/card.atlas',
      },
    },
  },
  gambleSymbol: {
    name: slotSpineKey.gambleSymbol,
    path: 'atlases/gambleFuture/web/symbol/symbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/web/symbol/symbol.atlas',
      },
    },
  },
  winCoin: {
    name: slotSpineKey.winCoin,
    path: 'atlases/winCoin/web/winCoin.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winCoin/web/winCoin.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  shake: {
    name: slotSpineKey.shake,
    path: 'atlases/shake/web/shake.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/shake/web/shake.atlas',
      },
    },
  },
  dust: {
    name: slotSpineKey.dust,
    path: 'atlases/dust/web/dust.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/dust/web/dust..atlas',
      },
    },
  },
  wheelLamp: {
    name: slotSpineKey.wheelLamp,
    path: 'atlases/boostedJackpotAtlases/wheelLamp/web/wheelLamp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelLamp/web/wheelLamp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelBlueBoard: {
    name: slotSpineKey.wheelBlueBoard,
    path: 'atlases/boostedJackpotAtlases/wheelBlueBoard/web/wheelBlueBoard.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelBlueBoard/web/wheelBlueBoard.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelSpinIcon: {
    name: slotSpineKey.wheelSpinIcon,
    path: 'atlases/boostedJackpotAtlases/spinButton/web/spinButton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/spinButton/web/spinButton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelIcon: {
    name: slotSpineKey.wheelIcon,
    path: 'atlases/boostedJackpotAtlases/wheelIcon/web/wheelIcon1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelIcon/web/wheelIcon1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  popup: {
    name: slotSpineKey.popup,
    path: 'atlases/boostedJackpotAtlases/popup/web/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/popup/web/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  lightning: {
    name: slotSpineKey.lightning,
    path: 'atlases/boostedJackpotAtlases/lightning/web/lightning.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/lightning/web/lightning.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

const mobileSceneSpineResources = {
  1: {
    name: slotBarSymbolNames.icon1,
    path: 'atlases/slotCharacters/mobile/symbol1/symbol1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol1/symbol1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  2: {
    name: slotBarSymbolNames.icon2,
    path: 'atlases/slotCharacters/mobile/symbol2/symbol2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol2/symbol2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  3: {
    name: slotBarSymbolNames.icon3,
    path: 'atlases/slotCharacters/mobile/symbol3/symbol3.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol3/symbol3.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  4: {
    name: slotBarSymbolNames.icon4,
    path: 'atlases/slotCharacters/mobile/symbol4/symbol4.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol4/symbol4.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  5: {
    name: slotBarSymbolNames.icon5,
    path: 'atlases/slotCharacters/mobile/symbol6/symbol6.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol6/symbol6.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  6: {
    name: slotBarSymbolNames.icon6,
    path: 'atlases/slotCharacters/mobile/symbol7/symbol7.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol7/symbol7.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  7: {
    name: slotBarSymbolNames.icon7,
    path: 'atlases/slotCharacters/mobile/symbol5/symbol5.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol5/symbol5.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  8: {
    name: slotBarSymbolNames.icon8,
    path: 'atlases/slotCharacters/mobile/symbol8/symbol8.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol8/symbol8.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  9: {
    name: slotBarSymbolNames.icon9,
    path: 'atlases/slotCharacters/mobile/wild/wild.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/wild/wild.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  10: {
    name: slotBarSymbolNames.icon11,
    path: 'atlases/slotCharacters/mobile/scatter2/scatter2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/scatter2/scatter2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  11: {
    name: slotBarSymbolNames.icon10,
    path: 'atlases/slotCharacters/mobile/scatter1/scatter1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/scatter1/scatter1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  400: {
    name: slotBarSymbolNames.icon12,
    path: 'atlases/slotCharacters/mobile/jackpotSymbol/jackpotSymbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/jackpotSymbol/jackpotSymbol.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  jackpotCongratsPopup: {
    name: slotSpineKey.jackpotCongratsPopup,
    path: 'atlases/jackpotAssets/mobile/jackpotCongratsPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotCongratsPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    name: slotSpineKey.jackpotGameSceneBoard,
    path: 'atlases/jackpotAssets/mobile/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackpotBackGroundLights: {
    name: slotSpineKey.jackpotBackGroundLights,
    path: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_lights.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_lights.atlas',
      },
    },
  },
  jackpotBackGroundLogo: {
    name: slotSpineKey.jackpotBackGroundLogo,
    path: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_logo.atlas',
      },
    },
  },
  jackpotBackGroundProjector: {
    name: slotSpineKey.jackpotBackGroundProjector,
    path: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_projector.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_projector.atlas',
      },
    },
  },
  jackpotBackGroundStage: {
    name: slotSpineKey.jackpotBackGroundStage,
    path: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_stage.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_stage.atlas',
      },
    },
  },
  jackpotBackGroundStars: {
    name: slotSpineKey.jackpotBackGroundStars,
    path: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_stars.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBackGround/bg_stars.atlas',
      },
    },
  },
  jackPotItem: {
    name: slotSpineKey.jackPotItem,
    path: 'atlases/jackpotAssets/mobile/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    name: slotSpineKey.jackpotAmountBoard,
    path: 'atlases/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackPotSymbol: {
    name: slotSpineKey.jackPotSymbol,
    path: 'atlases/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopup: {
    name: slotSpineKey.jackpotWinPopup,
    path: 'atlases/jackpotAssets/mobile/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  board: {
    name: slotSpineKey.board,
    path: 'atlases/board/mobile/Board.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/board/mobile/Board.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  mainBg: {
    name: slotSpineKey.mainBg,
    path: 'atlases/mainBg/mobile/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/mainBg/mobile/background.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winPopup: {
    name: slotSpineKey.winPopup,
    path: 'atlases/winPopup/mobile/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winPopup/mobile/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winLine: {
    name: slotSpineKey.winLine,
    path: 'atlases/line/mobile/line.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/line/mobile/line.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gameLogo: {
    name: slotSpineKey.gameLogo,
    path: 'atlases/logo/mobile/Logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/logo/mobile/Logo.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gambleAmountFrame: {
    name: slotSpineKey.gambleAmountFrame,
    path: 'atlases/gambleFuture/mobile/amountFrame/amount.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/mobile/amountFrame/amount.atlas',
      },
    },
  },
  gambleCard: {
    name: slotSpineKey.gambleCard,
    path: 'atlases/gambleFuture/mobile/card/card.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/mobile/card/card.atlas',
      },
    },
  },
  gambleSymbol: {
    name: slotSpineKey.gambleSymbol,
    path: 'atlases/gambleFuture/mobile/symbol/symbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/mobile/symbol/symbol.atlas',
      },
    },
  },
  winCoin: {
    name: slotSpineKey.winCoin,
    path: 'atlases/winCoin/mobile/winCoin.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winCoin/mobile/winCoin.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  shake: {
    name: slotSpineKey.shake,
    path: 'atlases/shake/mobile/shake.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/shake/mobile/shake.atlas',
      },
    },
  },
  dust: {
    name: slotSpineKey.dust,
    path: 'atlases/dust/mobile/dust.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/dust/mobile/dust..atlas',
      },
    },
  },
  wheelLamp: {
    name: slotSpineKey.wheelLamp,
    path: 'atlases/boostedJackpotAtlases/wheelLamp/mobile/wheelLamp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelLamp/mobile/wheelLamp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelBlueBoard: {
    name: slotSpineKey.wheelBlueBoard,
    path: 'atlases/boostedJackpotAtlases/wheelBlueBoard/mobile/wheelBlueBoard.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelBlueBoard/mobile/wheelBlueBoard.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelIcon: {
    name: slotSpineKey.wheelIcon,
    path: 'atlases/boostedJackpotAtlases/wheelIcon/mobile/wheelIcon.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelIcon/mobile/wheelIcon.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelSpinIcon: {
    name: slotSpineKey.wheelSpinIcon,
    path: 'atlases/boostedJackpotAtlases/spinButton/mobile/spinButton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/spinButton/mobile/spinButton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  popup: {
    name: slotSpineKey.popup,
    path: 'atlases/boostedJackpotAtlases/popup/mobile/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/popup/mobile/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  lightning: {
    name: slotSpineKey.lightning,
    path: 'atlases/boostedJackpotAtlases/lightning/mobile/lightning.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/lightning/mobile/lightning.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

const webAtlases = {
  images: {
    name: 'images',
    path: 'atlases/images/web/images.json',
  },
  boostedJackpot: {
    name: 'boostedJackpot',
    path: 'atlases/images/web/boostedJackpot.json',
  },
  licenseImages: {
    name: 'licenseImages',
    path: 'atlases/images/web/licenseImages.json',
  },
  jackpot: {
    name: 'jackpot',
    path: 'atlases/images/web/jackpot.json',
  },
  gameImages: {
    name: 'gameImages',
    path: 'atlases/images/web/gameImages.json',
  },
  infoSection: {
    name: 'infoSection',
    path: 'atlases/images/web/infoSection.json',
  },
};

const mobileAtlases = {
  images: {
    name: 'images',
    path: 'atlases/images/mobile/images.json',
  },
  boostedJackpot: {
    name: 'boostedJackpot',
    path: 'atlases/images/mobile/boostedJackpot.json',
  },
  licenseImages: {
    name: 'licenseImages',
    path: 'atlases/images/web/licenseImages.json',
  },
  jackpot: {
    name: 'jackpot',
    path: 'atlases/images/mobile/jackpot.json',
  },
  gameImages: {
    name: 'gameImages',
    path: 'atlases/images/mobile/gameImages.json',
  },
  infoSection: {
    name: 'infoSection',
    path: 'atlases/images/mobile/infoSection.json',
  },
};

export const initialResourceWeb = {
  loading: {
    name: 'loading',
    path: 'atlases/loading/web/loading.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/loading/web/loading.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

export const initialResourceMobile = {
  loading: {
    name: 'loading',
    path: 'atlases/loading/mobile/loading.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/loading/mobile/loading.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  loadingBackground: {
    name: 'loadingBackground',
    path: 'atlases/images/mobile/loadingBackground.png',
  },
};

export const initialGameResources = [
  ...Object.values(isMobile() ? initialResourceMobile : initialResourceWeb),
];

export const gameResources = [
  ...Object.values(fonts),
  ...Object.values(bitmapFonts),
  ...Object.values(isMobile() ? mobileSceneSpineResources : webSceneSpineResources),
  ...Object.values(isMobile() ? mobileAtlases : webAtlases),
];
